import React, { Component } from 'react';
import './App.css';
import InputRange from 'react-input-range';
import { Button, Col, Jumbotron, Row } from 'reactstrap';

import {
  AVG_CAREER_YEARS,
  AVG_MONTHLY_LIVING_FEES_STUDENT,
  AVG_SALARY_YEARLY_INCREASE_GRADUATE,
  AVG_STUDIES_DURATION,
  DEGREES,
  SLIDER_DEFAULT_VALUE,
  SLIDER_MAX_VALUE,
  SLIDER_MIN_VALUE,
  SLIDER_STEP,
} from './constants';
import { format, round } from './math';
import IconHelp from './IconHelp';

class App extends Component {
  constructor(props) {
    super(props);

    this.handleSliderMinus = this.handleSliderMinus.bind(this);
    this.handleSliderPlus = this.handleSliderPlus.bind(this);
    this.calcContributionPercentage = this.calcContributionPercentage.bind(this);
    this.calcMinimumContributors = this.calcMinimumContributors.bind(this);
    this.calcMonthlySalaryDifferenceAmount = this.calcMonthlySalaryDifferenceAmount.bind(this);
    this.calcYourContributionAmount = this.calcYourContributionAmount.bind(this);
    this.calcLifetimeSalaryDifferenceAmount = this.calcLifetimeSalaryDifferenceAmount.bind(this);

    this.state = {
      slider: {
        value: SLIDER_DEFAULT_VALUE,
      },
    };
  }

  handleSliderMinus() {
    this.setState({
      slider: {
        value: this.state.slider.value - SLIDER_STEP,
      },
    });
  }

  handleSliderPlus() {
    this.setState({
      slider: {
        value: this.state.slider.value + SLIDER_STEP,
      },
    });
  }

  calcContributionPercentage() {
    return round(this.state.slider.value / (AVG_MONTHLY_LIVING_FEES_STUDENT * 12 * AVG_STUDIES_DURATION) * 100);
  }

  calcMinimumContributors() {
    return Math.ceil((AVG_MONTHLY_LIVING_FEES_STUDENT * 12 * AVG_STUDIES_DURATION) / this.state.slider.value);
  }

  calcMonthlySalaryDifferenceAmount() {
    const monthlySalaryGraduate = DEGREES.find((degree) => degree.value === 'bac+5-sci').estimatedMonthlySalary;
    const monthlySalaryBachelor = DEGREES.find((degree) => degree.value === 'bac-gen').estimatedMonthlySalary;

    return monthlySalaryGraduate - monthlySalaryBachelor;
  }

  calcYourContributionAmount() {
    return (this.calcContributionPercentage() / 100 * this.calcLifetimeSalaryDifferenceAmount());
  }

  calcLifetimeSalaryDifferenceAmount() {
    const monthlySalaryGraduate = DEGREES.find((degree) => degree.value === 'bac+5-sci').estimatedMonthlySalary;
    const monthlySalaryBachelor = DEGREES.find((degree) => degree.value === 'bac-gen').estimatedMonthlySalary;

    return round(((monthlySalaryGraduate * AVG_SALARY_YEARLY_INCREASE_GRADUATE) - monthlySalaryBachelor) * 12 * AVG_CAREER_YEARS, 0);
  }

  render() {
    const { slider } = this.state;

    return (
      <div className="impact-social container">
        <header className="header">
          <a href={'https://studylink.fr'} target={'_blank'}>
            <img src={'https://storage.googleapis.com/studylink/logo.svg'} className="logo" alt="logo" />
          </a>
          <h2>
            Financer un étudiant lui rapporte beaucoup plus que vous ne le pensez&nbsp;...
          </h2>
        </header>

        <div className={'simulator'}>
          <h3>
            Découvrez combien&nbsp;...&nbsp;!
          </h3>

          <div>
            <div className={'small-vertical-spacing'}>
              <p>
                Un étudiant a besoin, <i>en moyenne</i>, de <b className={'cute-number-maumau-xlove'}>36 000€</b> pour
                effectuer une formation BAC +5.
              </p>
              <p>
                En participant au financement de ses études pour un montant
                de <b className={'cute-number-maumau-xlove'}>{format(this.state.slider.value)}€</b>, <br />
              </p>
              <p>
                cela contribuera à hauteur
                de <b className={'cute-number-maumau-xlove'}>{format(this.calcYourContributionAmount())}€</b> de ses
                revenus futurs&nbsp;!
              </p>
            </div>
          </div>

          <div className={'slider'}>
            <InputRange
              minValue={SLIDER_MIN_VALUE}
              maxValue={SLIDER_MAX_VALUE}
              value={slider.value}
              onChange={value => this.setState({
                slider: {
                  value,
                },
              })}
              formatLabel={(value) => {
                return `${value}€`;
              }}
              step={SLIDER_STEP}
            />
            <div className={'subtitle'}>
              Montant mis à disposition d'un étudiant
              {/*<IconHelp className="help-max-amount" text={`Montant moyen nécessaire pour permettre à un étudiant d'atteindre le niveau Bac&nbsp;+5`} />*/}
            </div>
          </div>
          <div className={'buttons clearfix'}>
            <Button
              className={'minus float-left'}
              color={'primary'}
              disabled={this.state.slider.value <= SLIDER_STEP}
              onClick={this.handleSliderMinus}
            >
              -
            </Button>
            <Button
              className={'plus float-right'}
              color={'primary'}
              onClick={this.handleSliderPlus}
            >
              +
            </Button>
          </div>
        </div>

        <div className={'simulator-results'}>
          <div className={'during-studies'}>
            <p>
              Soit&nbsp;
              <b
                className={'cute-number-maumau-xlove'}
                style={{ display: 'inline' }}
              >
                {this.calcContributionPercentage()}%
              </b> du besoin en financement d'un étudiant souhaitant effectuer un Bac&nbsp;+5
            </p>

            <p>
              <b
                className={'cute-number-maumau-xlove'}
                style={{ display: 'inline' }}
              >
                {this.calcMinimumContributors()}
              </b> contributions similaires permettraient à cet étudiant d'atteindre le niveau Bac&nbsp;+5, sans difficultés financières
              &nbsp;
              <IconHelp
                text={'15 000 étudiants par an sont contraints d\'abandonner leurs études supérieures pour des raisons financières'}
              />
              <br />
            </p>
          </div>

          <Jumbotron className={'after-studies'}>
            <div className={'top'}>
              <h3>Valeur créée grâce à l'obtention du niveau Bac&nbsp;+5</h3>

              <div>
                Revenus supplémentaires générés par l'étudiant au cours de sa vie comparé à un titulaire du Bac<br />
                <b className={'big'}>grâce à votre contribution</b><br />
                <p className={'cute-number-maumau-xlove'}>{format(this.calcYourContributionAmount())}€</p>
              </div>
            </div>

            <Row>
              <Col sm="6" xs="12" className={'left'}>
                <h5>Probabilité d'emploi dans les 4 ans</h5>

                <h2 className={'cute-number-maumau-xlove'}>91%</h2>
                <p>soit</p>
                <div>
                  <p className={'big'} style={{ margin: 0 }}>+15 pts</p>
                  <p className={'small'}>comparé à un titulaire du Bac</p>
                </div>
              </Col>

              <Col sm="6" xs="12" className={'right'}>
                <h5>Gain sur le salaire</h5>

                <p className={'cute-number-maumau-xlove'}>
                  +{format(this.calcMonthlySalaryDifferenceAmount())}€&nbsp;/&nbsp;mois
                </p>
                <p>soit</p>
                <div>
                  <p className={'big'} style={{ margin: 0 }}>+{format(this.calcLifetimeSalaryDifferenceAmount())}€</p>
                  <p className={'small'}>au cours de sa vie</p>
                </div>
              </Col>
            </Row>

          </Jumbotron>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js